import { render, staticRenderFns } from "./BtcSendModal.vue?vue&type=template&id=ae3812fc&scoped=true&"
import script from "./BtcSendModal.vue?vue&type=script&lang=ts&"
export * from "./BtcSendModal.vue?vue&type=script&lang=ts&"
import style0 from "./BtcSendModal.vue?vue&type=style&index=0&id=ae3812fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3812fc",
  null
  
)

export default component.exports